<template>
  <div class="editor-module-container">
    <div class="editor-module-title">
      <div
        class="left-content"
        @click="clickRenameModule('', cvDetail.submodule_info.orgs_title)"
      >
        <img v-if="moduleIcon" class="module-icon" :src="moduleIcon" alt="" />
        <div class="module-title">{{ cvDetail.submodule_info.orgs_title }}</div>
        <i class="iconfont iconedit-"></i>
        <div v-if="issueCount" class="module-issue-count">
          {{ issueCount }} 项待修复
        </div>
      </div>
      <div class="right-content">
        <i
          v-if="orgs.length > 1"
          class="iconfont iconpaixu"
        >
          <ExperienceSequence
            v-if="orgs.length > 1"
            :list="orgs"
            displayKey="name"
            @draggableChange="sequenceChange"
          />
        </i>
        <i
          class="iconfont iconshanchujianli"
          @click="handleClickRemoveModule"
        ></i>
      </div>
    </div>
    <div class="editor-form-list">
      <transition-group :name="displayAnimation ? 'list' : ''">
        <div
          v-for="item in orgs"
          :key="item.id"
          :id="`experience${item.id}`"
          class="editor-form-content"
          @click="editItem(item, 'sameInfo')"
        >
          <div class="form-item-header">
            <div class="form-item-title">
              <div class="form-item-name">{{ item.name }}</div>
              <div class="form-item-edit-content">
                <i
                  class="iconfont iconshanchujianli"
                  @click.stop="removeExperience(item)"
                ></i>
                <i
                  class="iconfont iconchevron-down"
                  :class="{ active: editId === item.id }"
                  @click.stop="editItem(item, 'sameInfo')"
                ></i>
              </div>
            </div>
            <div
              v-if="item.title || item.start_at || item.end_at || item.present"
              class="form-item-content"
            >
              <div class="content-text">{{ item.title }}</div>
              <div class="content-text">
                {{ item.start_at | formatDate }} -
                <span v-if="item.present">{{item.present}}</span>
                <span v-else>{{ item.end_at | formatDate }}</span>
              </div>
            </div>
          </div>
          <el-collapse-transition>
            <div
              v-show="editId === item.id"
              class="editor-module-content editor-base-form"
              @click.stop
            >
              <EditorInput
                v-model="item.name"
                clearable
                label="组织/活动名称"
                style="width: 100%"
                placeholder="请输入"
              />
              <EditorInput
                v-model="item.title"
                clearable
                label="你的角色"
                style="width: 100%"
                placeholder="请输入"
              />
              <EditorInput
                v-model="item.dept"
                placeholder="选填"
                clearable
                label="所在部门"
              />
              <EditorCityPicker
                :value="item.city"
                @confirm="cityChange($event, item)"
              />
              <EditorDatePickerRange
                label="工作时间"
                :startDate="item.start_at"
                :endDate="item.end_at"
                clearable
                :is-present="!!item.present"
                :itemData="item"
                @startDateChange="startDateChange($event, item)"
                @endDateChange="endDateChange"
              />
              <EditorRichText
                :description="item.description"
                :formData="item"
                :editId="editId"
                style="width: 100%"
                placeholder="介绍在什么活动中自己负责的内容，列出通过什么动作获得了什么成果"
                @contentChange="contentChange($event, item)"
              />
              <EditorAdviceBlock
                :item="item"
                module="orgs"
                :checkResult="checkResult"
                :suggestionList="returnCheckResultList(item.id, suggestionsModule)"
                :singleCheckLoading="singleCheckLoading"
                :repairIssueLoading="repairIssueLoading"
                @singleExperienceCheck="clickSingleExperienceCheck"
                @saveExperience="saveExperience"
                @resolveIssue="resolveIssue"
                @clickIgnore="clickIgnore"
                @buyMember="buyMember"
                @useOptimizationContent="useOptimizationContent"
              />
              <div class="complete-button-wrapper">
                <CompleteButton
                  text="保存"
                  :disabled="experienceEmpty('orgs', item.id, keys)"
                  @clickBtn="saveExperience(item.id, 'click')"
                />
              </div>
            </div>
          </el-collapse-transition>
        </div>
      </transition-group>
      <div
        v-if="displayAddBtn"
        class="editor-module-add"
        @click="clickAddExperience"
      >
        <i class="iconfont iconplus-circle"></i>
        <span>添加一段{{ cvDetail.submodule_info.orgs_title }}</span>
      </div>
    </div>
    <RenameModuleModal
      ref="renameModalRef"
      @confirm="confirmModuleRename($event, 'orgs')"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import api from '@/api';
import { editorFormMixin } from '../../mixins/editor-form';
import moment from 'moment';
import EditorInput from '../EditorInput/EditorInput.vue';
import EditorSelect from '../EditorSelect/EditorSelect.vue';
import EditorDatePickerRange from '../EditorDatePickerRange/EditorDatePickerRange.vue';
import EditorCityPicker from '../EditorCityPicker/EditorCityPicker.vue';
import EditorAutoComplete from '../EditorAutoComplete/EditorAutoComplete.vue';
import EditorRichText from '../EditorRichText/EditorRichText.vue';
import ExperienceSequence from '../ExperienceSequence/ExperienceSequence.vue';
import RenameModuleModal from '../RenameModuleModal/RenameModuleModal.vue';
import CompleteButton from '../CompleteButton/CompleteButton.vue';
import EditorAdviceBlock from '../EditorAdviceBlock/EditorAdviceBlock.vue';

const keys = ['name', 'title', 'dept', 'city', 'start_at', 'end_at', 'present'];

export default {
  name: 'EditorOrgModule',
  mixins: [editorFormMixin],
  components: {
    EditorInput,
    EditorSelect,
    EditorDatePickerRange,
    EditorCityPicker,
    EditorAutoComplete,
    EditorRichText,
    ExperienceSequence,
    RenameModuleModal,
    CompleteButton,
    EditorAdviceBlock,
  },
  props: {
    editId: {
      type: [String, Number],
      default: '',
    },
    suggestionsModule: {
      type: Object,
      default: () => ({}),
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keys,
    };
  },
  computed: {
    ...mapState('editor', ['cvDetail', 'orgs']),
    ...mapState('cvs', ['section_titles']),
    displayAddBtn() {
      return this.orgs.every((item) => item.id !== 'orgs-edit');
    },
  },
  filters: {
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('YYYY.MM');
    },
  },
  watch: {
    editId(_, oldVal) {
      if (this.clickSaveBtn) return;
      if (oldVal === 'orgs-edit') {
        this.checkModuleEmpty('orgs', oldVal, keys);
      } else if (oldVal) {
        this.saveExperience(oldVal);
      }
    },
  },
  methods: {
    clickSingleExperienceCheck(item, type) {
      if (this.singleCheckLoading) return;
      this.singleCheckLoading = true;
      this.saveExperience(item.id, false, async () => {
        await this.singleExperienceCheck(item, type);
        this.singleCheckLoading = false;
      });
    },
    saveExperience(id, operation, callback) {
      const payload = this.orgs.find((item) => item.id === id);
      if (!payload) return;
      payload.lang = this.cvDetail.basic_info.lang;
      this.updateFormExperience(payload, 'orgs', operation, callback);
    },
    async resolveIssue(item, type) {
      this.repairIssueLoading = true;
      const result = await this.clickRepairIssue(item, type);
      this.repairIssueLoading = false;
      if (result === 'success') {
        this.saveExperience(item.id);
      }
    },
    sequenceChange() {
      this.experienceSequenceChange('orgs');
    },
    async handleClickRemoveModule() {
      const confirm = await this.$wondercv.showConfirm({
        title: '温馨提示',
        content: `确定要删除${this.cvDetail.submodule_info.orgs_title || ''}吗？`,
        warningText: '模块删除后无法恢复',
        confirmText: '确认',
        cancelText: '取消',
      });
      if (confirm) {
        this.clickRemoveModule('orgs');
      }
    },
    startDateChange(value, item) {
      item.start_at = value;
    },
    endDateChange(value, isPresent, item) {
      let lang = this.cvDetail.basic_info.lang;
      if (isPresent) {
        item.end_at = null;
        item.present = lang == 'cn' ? "至今" : 'Present';
      } else {
        item.end_at = value;
        item.present = '';
      }
    },
    cityChange(data, item) {
      if (typeof data === 'string') {
        item.city = data;
        item.city_id = null;
      } else {
        item.city = data.name;
        item.city_id = data.id;
      }
    },
    contentChange(value, item) {
      item.description = value;
    },
    clickAddExperience() {
      this.$store.commit('editor/setModuleData', {
        type: 'orgs',
        info: [
          ...(this.orgs || []),
          {
            id: 'orgs-edit',
            name: '',
            title: '',
            dept: '',
            city: '',
            start_at: '',
            end_at: '',
            present: '',
            description: '',
          },
        ],
      });
      this.$emit('editItem', 'orgs-edit');
    },
    async removeExperience(item) {
      try {
        const confirm = await this.$wondercv.showConfirm({
          title: '温馨提示',
          content: `确定要删除${item.name || ''}吗？`,
          warningText: '经历删除后无法恢复',
          confirmText: '确认',
          cancelText: '取消',
        });
        if (confirm) {
          this.clickRemoveExperience(item, 'orgs');
        }
      } catch (error) {
        console.log(error);
      }
    },
    editItem(item, sameInfo) {
      this.$emit('editItem', item.id, sameInfo);
    },
    async fetchCompaniesRemoteMethod(query) {
      try {
        if (!query) return [];
        return await api.cvsEditor.companyAutoCompletions({
          keyword: query,
        });
      } catch (error) {
        console.log(error);
      }
    },
    async fetchTitlesRemoteMethod(query) {
      try {
        if (!query) return [];
        return await api.cvsEditor.positionAutoCompletionsIntention({
          keyword: query,
        });
      } catch (error) {
        console.log(error);
      }
    },
    buyMember() {
      this.$emit('buyMember');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
@import '../../styles/editor.scss';
</style>
